import { get } from 'lodash';

const root = state => get(state, 'ManageOrderItemState.createEditOrder');

export const getAllSiteItemsLoading = state =>
  get(root(state), 'getAllSiteItems.loading');
export const getAllSiteItemsResult = state =>
  get(root(state), 'getAllSiteItems.data');
export const getAllSiteItemsErrors = state =>
  get(root(state), 'getAllSiteItems.errors');

export const getParItemsLoading = state =>
  get(root(state), 'getParItems.loading');
export const getParItemsResult = state => get(root(state), 'getParItems.data');
export const getParItemsErrors = state =>
  get(root(state), 'getParItems.errors');

export const postSaveOrderLoading = state =>
  get(root(state), 'postSaveOrder.loading');
export const postSaveOrderResult = state =>
  get(root(state), 'postSaveOrder.data');
export const postSaveOrderErrors = state =>
  get(root(state), 'postSaveOrder.errors');

export const getOrderDetailsLoading = state =>
  get(root(state), 'getOrderDetails.loading');
export const getOrderDetailsResult = state =>
  get(root(state), 'getOrderDetails.data');
export const getOrderDetailsErrors = state =>
  get(root(state), 'getOrderDetails.errors');

export const getOrderTypesLoading = state =>
  get(root(state), 'getOrderTypes.loading');
export const getOrderTypesResult = state =>
  get(root(state), 'getOrderTypes.data');
export const getOrderTypesErrors = state =>
  get(root(state), 'getOrderTypes.errors');



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/createEditOrder/selectors.js